import AbstractRequestTask from "../../AbstractRequestTask";
import Launcher from '../../../apa/Launcher';
import DeviceStorage from '../../../../components/DeviceStorage/DeviceStorage';
import { DISABLE_MODAL_RETRIES } from '../../../RequestManagerConstants';
import settings from "../../../../devices/all/settings";
import { isEnabledCenterNotificationsWithByUserType } from 'src/utils/Utils';

class IsLoggedInOttV4Task extends AbstractRequestTask {

  constructor(version = 'v4', fromLogout = false) {
    super();
    // this.version = version;
    this.fromLogout = fromLogout;

    this.isByUserType = isEnabledCenterNotificationsWithByUserType();
    this.version = this.isByUserType ? "v5" : version;
  }

  getHeaders() {
    return {};
  }
  
  getParams() {
    const params = super.getParams();
    const user_id = DeviceStorage.getItem('user_id') || '';
    delete params.api_version;
    delete params.user_token;
    delete params.device_name;
    delete params.device_so;

    return {...params, user_id};
  }
  
  getShowErrorModal(){
    return DISABLE_MODAL_RETRIES;
  }

  getUrl() {
    const protocol = 'http';
    const server = settings.use_mock_endpoint ? settings.mock.server : Launcher.get("akamai_mfwk");
    const endpoint = settings.use_mock_endpoint ? 'ClaroVideo/Isloggedin/1.0.0/user' : 'services/user'
    const version = this.version
    const apiname = 'ott/isloggedin';
    return `${protocol}://${server}/${endpoint}/${version}/${apiname}`;
  }

  isValid(data){
    if (!data.data || !data.data.user_token) {
      return false;
    }
    return true;
  }

  success(data, b) {
    this.resolve(data);
  }
}

export default IsLoggedInOttV4Task;


// WEBPACK FOOTER //
// ./src/requests/tasks/user/v4/IsLoggedInOttV4Task.js